module.exports = __webpack_public_path__ + "img/auth-bg.63afc951.svg";